import { carouselBreakpoints, carouselSlideOptions } from './builder';

export const BREAKPOINTS = [
  { name: 'mobile', minWidth: 0, columns: 2, gap: 16 },
  { name: 'tablet', minWidth: 375, columns: 2, gap: 16 },
  { name: 'tablet+', minWidth: 1280, columns: 3, gap: 16 },
  { name: 'desktop', minWidth: 1440, columns: 3, gap: 20 },
  { name: 'desktop+', minWidth: 2056, columns: 4, gap: 20 },
];

// matches the CarouselOptions defined in constants/builder.js
export const CAROUSEL_BREAKPOINTS = [
  { name: 'mobile', minWidth: 0, columns: carouselSlideOptions.small, gap: 8 },
  {
    name: 'tablet',
    minWidth: carouselBreakpoints.small,
    columns: carouselSlideOptions.medium,
    gap: 8,
  },
  {
    name: 'tablet+',
    minWidth: carouselBreakpoints.medium,
    columns: carouselSlideOptions.large,
    gap: 16,
  },
  {
    name: 'desktop',
    minWidth: carouselBreakpoints.large,
    columns: carouselSlideOptions.xlarge,
    gap: 16,
  },
];
